import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { hostname } from "../lib/format";

export function ProductLogo({ product, size = "md" }) {
  const box = size === "sm" ? "w-9 h-9 rounded-lg" : "w-14 h-14 rounded-xl";
  const img = size === "sm" ? "w-5 h-5" : "w-8 h-8";
  if (product.logo_url)
    return (
      <div className={`${box} shrink-0 bg-surface border border-neutral-200 shadow-sm flex items-center justify-center`}>
        <img src={product.logo_url} alt={`${product.name} logo`} className={`${img} object-contain`} loading="lazy" />
      </div>
    );
  return (
    <div
      className={`${box} shrink-0 flex items-center justify-center font-playfair text-xl text-white`}
      style={{ backgroundColor: product.accent_color || "#3730A3" }}
      aria-hidden="true"
    >
      {product.logo_initial || product.name.charAt(0)}
    </div>
  );
}

export default function ProductCard({ product }) {
  const domain = hostname(product.website_url);
  const visitUrl = product.affiliate_url || product.website_url;
  return (
    <div
      className="group bg-surface border border-neutral-200 rounded-xl p-7 hover:shadow-md hover:border-indigo-200 hover:-translate-y-0.5 transition-[transform,box-shadow,border-color] duration-300 flex flex-col min-w-0"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="flex items-start justify-between gap-4 mb-6">
        <ProductLogo product={product} />
        <span className="eyebrow text-[10px] text-right leading-relaxed">{product.category}</span>
      </div>
      <h3 className="font-playfair text-2xl text-neutral-900">{product.name}</h3>
      {domain && <p className="text-xs text-neutral-500 mt-1">{domain}</p>}
      <p className="text-sm text-neutral-600 leading-relaxed mt-4 mb-6 flex-1">
        {product.description}
      </p>
      <div className="pt-5 border-t border-neutral-100 flex items-center justify-between gap-3">
        <Link
          to={`/reviews/${product.slug}-review`}
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-indigo-800 hover:text-indigo-950 transition-colors"
          data-testid={`product-read-review-${product.slug}`}
        >
          Read review <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
        </Link>
        {visitUrl && (
          <a
            href={visitUrl}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="inline-flex items-center gap-1 text-xs font-medium text-neutral-500 hover:text-indigo-800 transition-colors"
            data-testid={`product-visit-${product.slug}`}
          >
            Visit site <ArrowUpRight size={13} />
          </a>
        )}
      </div>
    </div>
  );
}
